import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/products`)
      .then(res => res.json())
      .then(data => {
        setProducts(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to fetch products:', err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="products-loading">
        <div className="text-2xl font-['Fredoka'] text-[#FFB800]">Loading products...</div>
      </div>
    );
  }

  return (
    <div className="content-wrapper py-12 px-4 sm:px-6 lg:px-8 min-h-screen" data-testid="products-page">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-5xl sm:text-6xl font-black font-['Fredoka'] text-[#3A1C00] text-center mb-6" data-testid="products-title">
            Our Products
          </h1>
          <p className="text-xl text-[#7D5A35] text-center mb-16 font-['Nunito']" data-testid="products-subtitle">
            Discover our full range of fruity lip care essentials
          </p>
        </motion.div>

        {products.length === 0 ? (
          <div className="text-center py-24" data-testid="no-products-message">
            <p className="text-2xl text-[#7D5A35] font-['Fredoka']">No products available yet. Check back soon!</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
            {products.map((product, index) => (
              <motion.div
                key={product.id}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                data-testid={`product-card-${index}`}
              >
                <Link to={`/products/${product.id}`}>
                  <div className="product-card group">
                    <div className="aspect-square rounded-3xl overflow-hidden mb-6 bg-[#FFFDF7]">
                      <img 
                        src={product.image} 
                        alt={product.name}
                        className="w-full h-full object-cover"
                        data-testid={`product-image-${index}`}
                      />
                    </div>
                    <div className="space-y-3">
                      <span className="badge badge-stock" data-testid={`product-stock-${index}`}>{product.stock_status}</span>
                      <h3 className="text-2xl font-bold font-['Fredoka'] text-[#3A1C00]" data-testid={`product-name-${index}`}>
                        {product.name}
                      </h3>
                      <p className="text-[#7D5A35] line-clamp-2 leading-relaxed" data-testid={`product-description-${index}`}>
                        {product.description}
                      </p>
                      <p className="text-3xl font-black font-['Fredoka'] text-[#FFB800]" data-testid={`product-price-${index}`}>
                        ${product.price.toFixed(2)}
                      </p>
                      {product.variants && product.variants.length > 0 && (
                        <div className="flex flex-wrap gap-2" data-testid={`product-variants-${index}`}>
                          {product.variants.slice(0, 3).map((variant, vIndex) => (
                            <span key={vIndex} className="badge badge-variant text-xs">
                              {variant.name}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Products;